module.exports = "<template> <div class=colorbox css.bind=\"'background-color: ' + value + ';'\"></div> </template> ";